export const versions = {
  version: "1.0.183",
  revision: "c99e49fd2",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5121-gc99e49fd2-dirty",
    hash: "gc99e49fd2",
    distance: 5121,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5121-gc99e49fd2-dirty",
    semverString: "1.0.183+5121.gc99e49fd2.dirty"
  }
};
